import { getFormattedDate } from "@/utils/get-formatted-date"
import { LabeledValue } from "@components/default-list/labeled-value"
import { PersonName } from "@components/PersonName"
import { Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { WorkingTimeImportStatusBadge } from "./WorkingTimeImportStatusBadge"
import { WorkingTimeBookingDto } from "@/orval/gen"

export function WorkingTimeBookingStack({
  booking,
  withPerson = false,
}: {
  booking: WorkingTimeBookingDto
  withPerson?: boolean
}) {
  const { t } = useTranslation("app_server")
  return (
    <Stack>
      {withPerson && (
        <LabeledValue
          label={t("Person")}
          value={<PersonName personId={booking.personId} />}
        />
      )}
      <LabeledValue
        label={t("Time")}
        value={<Text>{getFormattedDate(booking.timeStamp, "L LT")}</Text>}
      />
      <LabeledValue
        label={t("Type")}
        value={<Text>{booking.type.name}</Text>}
      />
      <LabeledValue label={t("Source")} value={<Text>{booking.source}</Text>} />
      <LabeledValue
        label={t("Status")}
        value={<WorkingTimeImportStatusBadge status={booking.status} />}
      />
      {booking.note && (
        <LabeledValue label={t("Note")} value={<Text>{booking.note}</Text>} />
      )}
    </Stack>
  )
}
